import React from "react";
import styled from "@emotion/styled";
import theme from "../utils/theme";

const Wrapper = styled.div({
  display: "flex",
  flexDirection: "column",
  justifyContent: "center",
  alignItems: "center",
  height: "100vh",
  margin: "0 50px",
});

const Heading = styled.h1({
  color: theme.colors.orangeBackground,
  fontSize: "4rem",
  textAlign: "center",
});

const Text = styled.p({
  color: "white",
  fontSize: "2rem",
  textAlign: "center",
});

const ExplorerTemplate = () => (
  <Wrapper>
    <Heading>
      Omlouváme se, tento prohlížeč nestačí držet krok s naší appkou{" "}
      <span role="img" aria-label="smutný smajlík">
        😕
      </span>
    </Heading>
    <Text>Zkuste prosím použít jakýkoliv jiný prohlížeč</Text>
  </Wrapper>
);

export default ExplorerTemplate;
